import { FormikErrors } from "formik";
import { EMAIL_REGEX } from "utils/Common/Constant";

export interface LoginFormValues {
  email: string;
  password: string;
}

export const validateRequired = (value: string, fieldLabel: string): string => {
  if (!value || !value.trim()) return `${fieldLabel} is required`;
  return "";
};

export const validateEmail = (email: string): string => {
  const requiredError = validateRequired(email, "Email address");
  if (requiredError) return requiredError;
  if (!EMAIL_REGEX.test(email.trim())) return "Enter a valid email address";
  return "";
};

export const validateLoginForm = (
  values: LoginFormValues,
): FormikErrors<LoginFormValues> => {
  const errors: FormikErrors<LoginFormValues> = {};
  const emailError = validateEmail(values.email);
  const passwordError = validateRequired(values.password, "Password");
  if (emailError) errors.email = emailError;
  if (passwordError) errors.password = passwordError;
  return errors;
};
